<div class="vl-layout">
  <ng-content></ng-content>
</div>